(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Watch = mod.exports;
  }
})(this, function (exports, _react) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.Watch = undefined;
  var _react2 = _interopRequireDefault(_react);
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }
  var Watch = exports.Watch = function Watch(svg) {
    return _react2.default.createElement("svg", {
      width: svg.width,
      height: svg.height,
      version: "1.1",
      id: "L2",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      viewBox: "0 0 100 100",
      enableBackground: "new 0 0 100 100",
      xmlSpace: "preserve"
    }, _react2.default.createElement("circle", {
      fill: "none",
      stroke: svg.color,
      strokeWidth: "4",
      strokeMiterlimit: "10",
      cx: "50",
      cy: "50",
      r: "48"
    }), _react2.default.createElement("line", {
      fill: "none",
      strokeLinecap: "round",
      stroke: svg.color,
      strokeWidth: "4",
      strokeMiterlimit: "10",
      x1: "50",
      y1: "50",
      x2: "85",
      y2: "50.5"
    }, _react2.default.createElement("animateTransform", {
      attributeName: "transform",
      dur: "2s",
      type: "rotate",
      from: "0 50 50",
      to: "360 50 50",
      repeatCount: "indefinite"
    })), _react2.default.createElement("line", {
      fill: "none",
      strokeLinecap: "round",
      stroke: svg.color,
      strokeWidth: "4",
      strokeMiterlimit: "10",
      x1: "50",
      y1: "50",
      x2: "49.5",
      y2: "74"
    }, _react2.default.createElement("animateTransform", {
      attributeName: "transform",
      dur: "15s",
      type: "rotate",
      from: "0 50 50",
      to: "360 50 50",
      repeatCount: "indefinite"
    })));
  };
});